// extracted by mini-css-extract-plugin
export default {"reactions":"Jos8R7","mobile":"zvDJEn","android":"iJ2OVx","meeting":"Gz0wCT"};